import NotificationsOffIcon from "@mui/icons-material/NotificationsOff";
import { IconButton, Tooltip, Zoom } from "@mui/material";
import { usePostHog } from "posthog-js/react";

import { ErrorTypography } from "components/ErrorTypography";
import { LoadingWrappedNode } from "components/LoadingWrappedNode";
import { useUserChatInfo, useWriterComponentState } from "hooks";
import { channelExistsInChatInfo, getGroupChannelForChannel } from "utils";

import { ClientAppEvent } from "../../../../../constants";

interface Props {
  currentChannel: string;
}

export function MuteChatButton(props: Props) {
  const { currentChannel } = props;

  const {
    chatInfo,
    loading: loadingChatInfo,
    refreshChatInfo,
  } = useUserChatInfo();
  const posthog = usePostHog();

  const notificationsEnabled =
    chatInfo != null && channelExistsInChatInfo(chatInfo, currentChannel)
      ? getGroupChannelForChannel(currentChannel, chatInfo.channels)
          .notifications_enabled
      : false;

  const { write, error, loading } = useWriterComponentState({
    errorMessage:
      "Failed to mute chat. Please contact us directly using the chat bubble.",
    writeConfig: {
      method: "patch",
      url: "/user/channels/update",
      body: {
        channel_name: currentChannel,
        notifications_enabled: !notificationsEnabled,
      },
    },
  });

  const onUpdateSuccess = () => {
    posthog?.capture(ClientAppEvent.CHAT_NOTIFICATIONS_TOGGLED, {
      channel_id: currentChannel,
      muted: notificationsEnabled,
    });
    refreshChatInfo();
  };

  const onMuteChat = () => {
    write(onUpdateSuccess);
  };

  if (chatInfo == null || !channelExistsInChatInfo(chatInfo, currentChannel)) {
    return null;
  }

  return (
    <LoadingWrappedNode loading={loading || loadingChatInfo}>
      <Tooltip
        title={
          notificationsEnabled
            ? "Click to mute unread message email reminders."
            : "Click to enable unread message email reminders."
        }
        placement="right"
        TransitionComponent={Zoom}
      >
        <IconButton onClick={onMuteChat}>
          <NotificationsOffIcon
            fontSize="large"
            color={notificationsEnabled ? undefined : "error"}
          />
        </IconButton>
      </Tooltip>

      <ErrorTypography error={error} />
    </LoadingWrappedNode>
  );
}
